import { ColumnDef } from '@tanstack/react-table'
import { observer } from 'mobx-react-lite'
import { Item } from '~/shared/api/services/delivery/types'
import { Checkbox, HonestSignBadge } from '~/shared/ui'
import ImageWithFallback from '~/shared/ui/image-with-fallback'

const CheckboxAnHonestSign = observer((props: Pick<Item, 'id' | 'checked'>) => {
  const { checked, id } = props
  return <Checkbox key={id + Date.now()} checked={checked} />
})

export const DELIVERY_TABLE_CONFIG: ColumnDef<Item>[] = [
  {
    header: '',
    accessorKey: 'empty',

    cell: (row) => {
      return (
        <div className="ml-8">
          <CheckboxAnHonestSign
            checked={row.cell.row.original.checked}
            id={row.cell.row.original.id}
          />
        </div>
      )
    },
    maxSize: 50,
  },
  {
    header: 'anHonestSign',
    accessorKey: 'anHonestSign',

    cell: (row) => {
      const { original } = row.cell.row
      return original.mandatoryMarkField ? (
        <div className="ml-[35px]">
          <HonestSignBadge />
        </div>
      ) : null
    },
    maxSize: 70,
  },

  {
    header: 'manufacturer',
    accessorKey: 'manufacturer',

    cell: (row) => {
      const { original } = row.cell.row

      return <div> {original.brandName}</div>
    },
    maxSize: 150,
  },
  {
    header: 'Product name',
    accessorKey: 'Product name',

    cell: (row) => {
      const { original } = row.cell.row

      return <div> {original?.productName}</div>
    },
    maxSize: 150,
  },

  {
    header: 'options',
    accessorKey: 'options',

    cell: (row) => {
      const { original } = row.cell.row
      const { options } = original

      if (!options?.image && !options?.text) {
        return null
      }

      return (
        <div className="my-4">
          {options?.image && (
            <ImageWithFallback
              src={options.image}
              alt="foto"
              className="w-20 h-20 rounded "
            />
          )}

          {options?.text &&
            options.text.split('<br>').map((el) => <div key={el}>{el}</div>)}
        </div>
      )
    },
    maxSize: 150,
  },

  {
    header: 'image',
    accessorKey: 'image',

    cell: (row) => {
      const { original } = row.cell.row

      const imageSrc = original?.image

      return (
        <div className="w-[150px] h-[150px]  rounded shadow m-2">
          <ImageWithFallback
            className="w-full h-full object-contain rounded"
            src={imageSrc}
            alt="Product Thumbnail"
          />
        </div>
      )
    },
    maxSize: 100,
  },
]
